import { useCallback, useEffect, useState } from 'react';

import { Range } from '@app/shared/components';

import type { ContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';
import { FilterWrapper } from '@pages/Clients/NewClientsList/ui';

export const AgeFilter: ContentType = ({ open, onClose, id }) => {
  const { filtersMap, onChangeAgeRange } = useNewClientsListContext();
  const { ageRange } = filtersMap.get(id)!;

  const [localRange, setLocalRange] = useState<{
    from: number | null;
    to: number | null;
  }>({
    from: null,
    to: null,
  });

  const onConfirm = useCallback(() => {
    onChangeAgeRange(localRange, id);
    onClose?.();
  }, [id, localRange, onChangeAgeRange, onClose]);

  useEffect(() => {
    setLocalRange(open ? ageRange : { from: null, to: null });
  }, [open, ageRange]);

  return (
    <FilterWrapper onConfirm={onConfirm}>
      <Range
        values={localRange}
        onChange={(range) =>
          setLocalRange({ from: range.from ?? null, to: range.to ?? null })
        }
        fromTitle="от"
        toTitle="до"
        inputsClassName={`${PF}__range-inputs`}
        min={0}
        max={150}
      />
    </FilterWrapper>
  );
};
